<template>
    <div class="login-wrapper">
        <div class="login">
            <router-link id="link-home" to="/">
                <img src="../../assets/images/common/melchi-logo.png">
                <span><!--멸치패밀리 사이트-->{{$t("login.code001")}}</span>
            </router-link>
            <div class="login-content-wrapper">
                <div class="login-form">
                    <div>
                        <!--이메일-->
                        <input type="text" class="input-login" :placeholder="localeCode002" v-model="uid">
                    </div>
                    <div>
                        <!--비밀번호-->
                        <input type="password" class="input-login" :placeholder="localeCode003" v-model="password" @keyup.13="onLogin()">
                    </div>
                    <div class="save-id-wrapper">
                        <input type="checkbox" id="save-id" @click="saveUserID" v-model="saveUserIDChecked"> <label for="save-id"><!--이메일 저장-->{{$t("login.code004")}}</label>
                    </div>

                    <div v-on:click="onLogin()">
                        <a class="login-button"><!--로그인-->{{$t("login.code005")}}</a>
                    </div>
                    
                    <div class="links">
                        <router-link to="/signup/form"><!--회원가입-->{{$t("login.code006")}}</router-link>
                        |
                        <router-link to="/find-password"><!--비밀번호 찾기-->{{$t("login.code007")}}</router-link>
                    </div>
                </div>
                <div class="login-content">
                    <div class="inner">
                        <div class="intro-text">
                            <!--무제한 일거리제공-->{{$t("login.code008")}}<br>

                            <template v-if="localeLang === 'en'">
                                Welcome to <strong>Melchi Family</strong> Site.
                            </template>
                            <template v-else>
                                <strong>멸치패밀리 사이트</strong>에 오신 것을<br>
                                환영합니다.
                            </template>

                        </div>
                        <div class="contact">
                            <!--이용문의-->{{$t("login.code009")}}
                            <strong>1599-7409</strong>
                        </div>
                    </div>
                </div>
            </div>
            <footer>
                <div class="copyright">
                    Copyright (C) 2020 <strong>Melchi.</strong> All Rights Reserved.
                </div>
            </footer>
        </div>
        <div class="login-background"></div>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex' // mapGetters를 추가한다

    export default {
        created: function () {
            if (this.$store.state.isAuth) {
                //alert('이미 로그인 되어 있습니다')
                alert(this.$i18n.t('login.code010'))
                this.$router.push({path: '/'})
            }
            if(this.$cookie.get('savedUserID')){
                this.uid = this.$cookie.get('savedUserID')
                this.saveUserIDChecked = true
            }else{
                this.saveUserIDChecked = false
            }
        },
        computed: {
            localeLang() { return this.$i18n.t('lang') }, 
            localeCode002() {
                return this.$i18n.t('login.code002')
            },
            localeCode003() {
                return this.$i18n.t('login.code003')
            },
        },
        data: () => ({
            uid: '',
            password: '',
            saveUserIDChecked: false,
        }),
        methods: {
            ...mapActions(['login']),
            saveUserID() {
                if(this.saveUserIDChecked){
                    this.$cookie.delete('savedUserID')
                }else{
                    this.$cookie.set('savedUserID', this.uid)
                }
            },
            async onLogin() {
                try {
                    await this.login({uid: this.uid, password: this.password})

                    if(this.$store.state.errorState){
                        if (this.$store.state.errorCode == 'E003') {
                            location.href = "/email-auth?email=" + this.uid;
                        } else if (this.$store.state.errorCode == 'E001') {
                            //alert('비밀번호가 틀립니다. 다시 입력해 주세요.')
                            alert(this.$i18n.t('login.code011'))
                        } else if (this.$store.state.errorCode == 'E002') {
                            //alert('정상적인 회원이 아닙니다. 관리자에게 문의해 주세요.')
                            alert(this.$i18n.t('login.code012'))
                        } else {
                            alert(this.$store.state.errorState)
                        }
                    }
                } catch (err) {
                }
            }
        }
    }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    $defaultButtonBackgroundColor: #0099ff;
    $defaultButtonBackgroundColorHover: #0073bf;
    $defaultButtonTextColor: #ffffff;

    div.login-background {
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        position: fixed;
        background: #eceef1;
        z-index: 200;
    }

    div.login-wrapper {

        div.login {
            z-index: 201;
            position: relative;
            width: 900px;
            padding-top: 100px;
            margin: 0 auto;

            a#link-home {
                margin-left: 40px;
                span {
                    color: #1665b6;
                    font-size: 18px;
                    margin-left: 9px;
                }
            }

            div.login-content-wrapper {
                position: relative;

                div.login-form {
                    box-shadow: 0px 0px 12px 2px #cccccc;
                    margin-top: 28px;
                    display: inline-block;
                    padding: 55px;
                    background: #ffffff;
                    border-radius: 15px;
                    position: relative;
                    z-index: 202;

                    input.input-login {
                        font-size: 16px;
                        padding: 13px 15px;
                        border: 2px solid #d2d3d4;
                        background: #ffffff;
                        margin-bottom: 8px;
                        width: 238px;
                    }

                    a.login-button {
                        cursor: pointer;
                        font-size: 18px;
                        margin-top: 23px;
                        display: inline-block;
                        padding: 18px 0;
                        width: 272px;
                        text-align: center;
                        background: $defaultButtonBackgroundColor;
                        color: $defaultButtonTextColor;
                    }

                    a.login-button:hover {
                        background: $defaultButtonBackgroundColorHover;
                    }

                    div.save-id-wrapper {
                        margin-top: 0px;
                        font-size: 14px;
                        color: #666666;

                        input {
                            vertical-align: 10%;
                        }
                    }

                    div.links {
                        margin-top: 28px;
                        border-top: 1px solid #999999;
                        padding-top: 16px;
                        color: #999999;
                        text-align: center;

                        a {
                            color: #999999;
                            font-size: 14px;
                            margin: 0 5px;
                        }

                        a:hover {
                            color: #0099ff;
                        }
                    }
                }

                div.login-content {
                    width: 492px;
                    display: inline-block;
                    position: absolute;
                    z-index: 201;
                    bottom: 0;
                    right: 60px;
                    padding-top: 160px;
                    padding-bottom: 30px;
                    background: url("../../assets/images/login/login-background.png") left top no-repeat;

                    div.inner {
                        position: relative;

                        div.intro-text {
                            color: #1665b6;
                            font-size: 28px;
                            line-height: 115%;
                            margin-left: 80px;
                        }

                        div.contact {
                            margin-top: 12px;
                            margin-left: 80px;
                            color: #1665b6;
                            font-size: 16px;
                            padding-left: 36px;
                            padding-top: 18px;
                            background: url("../../assets/images/login/login-contact-icon.png") left top no-repeat;

                            strong {
                                margin-left: 10px;
                            }
                        }
                    }

                }

            }

        }

        footer {
            padding-top: 50px;
            padding-bottom: 17px;
            background: #edeff2;

            div.links {
                font-size: 14px;
                text-align: center;
                color: #666666;
                a {
                    font-size: 14px;
                    color: #666666;
                }
            }
            div.company-information {
                margin-top: 25px;
                text-align: center;
                font-size: 10px;
                line-height: 120%;
                color: #666666;
            }

            div.copyright {
                margin-top: 10px;
                color: #666666;
                font-size: 12px;
                text-align: center;

                strong {
                    font-weight: bold;
                }
            }
        }

    }
</style>



// WEBPACK FOOTER //
// src/components/user/Login.vue